<script setup lang="ts">
import AppCard from './AppCard.vue'
import { useGeoDataStore } from '~/stores/geoData'
import type { MatchmakingItem } from '~/types/types'
import AppSubItem from '@/components/app/AppSubItem.vue'
import AppHeading from '@/components/app/AppHeading.vue'
import AppChips from '@/components/app/AppChips.vue'
import AppChipsItem from '@/components/app/AppChipsItem.vue'
const geoDataStore = useGeoDataStore()
const { keyTranslator: operatorTranslator } = await useKeyTranslator('operator')
const { keyTranslator: fuelTypeTranslator } = await useKeyTranslator('fuelType')
const { keyTranslator: vehicleTypeTranslator } = await useKeyTranslator('vehicleType')
const props = defineProps<{ item: MatchmakingItem }>()
const county = computed(() => geoDataStore.getCountyByCountyId(props.item.county))
const { matchmakingTypeLabelTranslator } = useMathmakingUtils()
const matchmakingTypeLabel = computed(() => matchmakingTypeLabelTranslator(props.item))
</script>
<template>
  <AppCard>
    <div class="matchmaking-card h-full flex flex-column justify-content-between">
      <div>
        <AppHeading :title="operatorTranslator(item.operator)" type="h2" />
        <div class="flex" style="margin-left: -0.5rem">
          <div class="col">
            <AppSubItem v-if="item.fuel_type" :title="matchmakingTypeLabel">
              <AppChips>
                <AppChipsItem
                  v-for="(fuelTypeItem, i) in item.fuel_type"
                  :key="i"
                  :item="fuelTypeTranslator(fuelTypeItem)"
                  type="dark"
                />
              </AppChips>
            </AppSubItem>
          </div>
          <div class="col">
            <AppSubItem v-if="item.start_date || item.end_date" title="Giltighetstid">
              <AppChips>
                <AppChipsItem v-if="item.start_date" :item="item.start_date" type="outlined" />
                <AppChipsItem v-if="item.end_date" :item="item.end_date" type="outlined" />
              </AppChips>
            </AppSubItem>
          </div>
        </div>
        <div class="flex" style="margin-left: -0.5rem; margin-right: -0.5rem">
          <div class="col">
            <AppSubItem v-if="county" title="Plats" :description="county.name" />
          </div>
          <div class="col">
            <AppSubItem v-if="item.vehicle_type.length > 0" title="Fordonstyp">
              <span v-for="(vehicleTypeItem, i) in item.vehicle_type" :key="i" class="separator">{{
                vehicleTypeTranslator(vehicleTypeItem)
              }}</span>
            </AppSubItem>
          </div>
        </div>
      </div>
      <div>
        <hr aria-hidden="true" />
        <div class="flex align-items-end justify-content-between footer__row">
          <NuxtLink :to="`/samarbeta/${item.slug}`"
            ><Button
              class="green-button outlined"
              label="Läs mer"
              severity="secondary"
              outlined
              rounded
              :aria-label="`Läs mer om inlägget som är skapat av ${item.operator_name}`"
          /></NuxtLink>
          <AppSubItem
            v-if="item.operator_name"
            title="Skapat av"
            :description="`${item.operator_name}`"
          />
        </div>
      </div>
    </div>
  </AppCard>
</template>
<style lang="scss" scoped>
@import 'App.scss';
.footer__row {
  flex-direction: row-reverse;
}
.separator {
  &::after {
    content: ', ';
  }

  &:last-of-type {
    &::after {
      content: '';
    }
  }
}
</style>
